<template>
  <div class="text-xs-center">
    <img
      class="payment_img payment-success_img"
      src="/img/icons/success.svg"
    />
    <h2 class="payment_title">{{$t('pay.success.title')}}</h2>
    <h3 class="payment_subtitle">{{$t('pay.success.subtitle')}}</h3>
    <p class="payment_text">{{$t('pay.success.text')}} <a href="mailto:team@robinhood-tierschutz.at">team@robinhood-tierschutz.at</a></p>
    <v-btn
      :to="{ name: 'UserFeed' }"
      color="primary"
    >
      {{$t('pay.success.button')}}
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'Success',
  };
</script>

<style lang="scss" scoped>
  .payment {
    &_img {
      height: 150px;
      width: 150px;
      margin: 20px 0;
    }

    &-success {
      &_img {
        margin: 20px 0 0;
      }
    }

    &_title {
      margin-bottom: 20px;
      color: rgba(0, 0, 0, 0.65);
      font-size: 24px;
      line-height: 28px;
      font-weight: normal;
    }

    &_subtitle {
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.65);
    }

    &_text {
      font-size: 20px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.65);
      margin: 20px auto;
      width: 45%;
    }
  }
</style>
